import React from 'react';
import { useAppSelector } from '../../store/hooks/hooks';
import { PROCESSES_COLUMNS } from '../../common/initialValues/initialValues';
import { useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import arrowDown from '../../assets/icons/arrow-down-orange-icon.svg';
import emptyTableIcon from '../../assets/icons/empty-state-illustration.svg';
import { GlobalFilter } from '../dashboard/GlobalFilter';
import { Pagination } from '../reusableWidgets/Pagination';

export const ProcessesTable = () => {
  const reachedProcesses = useAppSelector((state) => state.processes.reachedProcesses);

  const columns = React.useMemo(() => PROCESSES_COLUMNS, []);
  const data = React.useMemo(() => reachedProcesses, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    prepareRow,
    canNextPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    state,
    rows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      // initialState: { pageIndex: 0 },
      initialState: { pageSize: 50 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { pageIndex, pageSize, globalFilter } = state;

  let paginationRowsArray: Array<number> = [];
  if (rows.length <= 10) paginationRowsArray = [rows.length];
  if (rows.length > 10) paginationRowsArray = [10, rows.length];
  if (rows.length > 50) paginationRowsArray = [10, 50, rows.length];
  if (rows.length > 100) paginationRowsArray = [10, 50, 100, rows.length];
  if (rows.length > 500) paginationRowsArray = [10, 50, 100, 500];

  return (
    <div className='relative font-h5-regular margin-bottom-3'>
      <div className='filters'>
        <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
      </div>
      {page.length ? (
        <>
          <table className='font-h5-regular simply-table' {...getTableProps}>
            <thead className='simply-table__head'>
              {headerGroups.map((headerGroup) => (
                <tr className='simply-table__head__row' {...headerGroup.getFooterGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className={`${column.isSorted && 'primary-200'} simply-table__head__row__th font-h5-regular`}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <span>{column.render('Header')}</span>

                      {column.isSorted ? <img src={arrowDown} alt='' className={`${column.isSortedDesc && 'rotate-180'}`} /> : ''}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody className='simply-table__body' {...getTableBodyProps}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr className='simply-table__body__row' {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return (
                        <td className='simply-table__body__column' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          <Pagination
            rowsLength={rows.length}
            pageCount={pageCount}
            pageIndex={pageIndex}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            canNextPage={canNextPage}
            gotoPage={gotoPage}
            previousPage={previousPage}
            nextPage={nextPage}
            setPageSize={setPageSize}
          />
        </>
      ) : (
        <>
          <div className='text-center padding-top-4'>
            <picture className='height-60'>
              <img className='height-60' src={emptyTableIcon} alt='' />
            </picture>
            <h3 className='font-h3-regular margin-top-1'>Nothing here yet</h3>
          </div>
        </>
      )}
    </div>
  );
};
